import styled from 'styled-components'
import Drawer from 'components/common/Drawer'
import Mixin from 'components/common/Mixin'

export const StyledDrawer = styled(Drawer)`
  border-top: 0;
  border-left: 0;
  border-right: 0;
  margin-top: 45px;
  padding: 0;
`

export const ErrorMessage = styled.div`
  margin: 20px 0;
  color: red;
  ${Mixin.font.GothamBold()}
`
